import {useEffect, useState} from "react";
import {Dialog, DialogActions, DialogContent, makeStyles, Typography} from "@material-ui/core";
import {set, insert, del} from "object-path-immutable";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";

import FieldPropertiesComponent from "../../../FieldPropertiesComponent/FieldPropertiesComponent";
import findByString from "../../../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import DefaultType from "../../../../../../../Utils/Form/FormDynamic/Fields/DefaultType/DefaultType";
import ScriptType from "../../../../../../../Utils/Form/FormDynamic/Fields/ScriptType";
import TypeEntity from "../../../../../../../Utils/Form/FormDynamic/Fields/EntityExternal/Entity";
import Choices from "../Choices/Choices";
import useConfirm from "../../../../../Utils/Confirmation/useConfirm";
import PointsConditions from "./PointsConditions";
import PointsScript from "./PointsScript";

const useStyles = makeStyles(() => ({
    dialogPaper: {
        height: '100%'
    },
    contentContainer: {
        display: 'flex', flexDirection: 'column', height: '100%'
    },
    content: {
        padding: 10,
        width: '50%',
        display: 'flex',flexDirection: 'column'
    },
    contentBordered: {
        padding: 10,
        border: '1px solid #ccc',
        borderRadius: 8,
        height: '100%'
    },
    noSelectedContainer: {
        width: '100%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'rgba(0,0,0,0.02)',
        borderRadius: 10
    }
}))

const QuestionModal = ({open, onClose, surveyType, record, saveQuestion}) => {
    const [question, setQuestion] = useState();
    const [isChanged, setIsChanged] = useState(false);
    const selectedType = findByString(question, `type`)
    const classes = useStyles();
    const {confirm} = useConfirm();

    useEffect(() => {
        if (open) {
            if (record) {
                setQuestion(record)
            }
        } else {
            setQuestion({})
        }
    }, [open]);

    function onChangeFields(v, p) {
        const newValues = set(question, p, v)
        setIsChanged(true);
        setQuestion(newValues)
    }

    function addGroup(index) {
        const newValues = insert(question, 'pointsConditions', {}, index)
        setIsChanged(true);
        setQuestion(newValues)
    }

    function removeGroup(index) {
        if (question.pointsConditions.length === 1) {
            setQuestion(prev => {
                return {
                    ...prev,
                    pointsConditions: undefined
                }
            })
            return;
        }
        const newValues = del(question, `pointsConditions.${index}`,)
        setIsChanged(true);
        setQuestion(newValues)
    }

    function onCloseDialog() {
        if (isChanged) {
            confirm({
                title: 'You have unsaved data',
                submitFn: () => {
                    onClose();
                    setIsChanged(false)
                }
            })
            return;
        }
        setIsChanged(false)
        onClose();
    }

    return (
        <Dialog open={open} onClose={onCloseDialog} maxWidth={"lg"} fullWidth={true}
                classes={{paper: classes.dialogPaper}}
        >
            <DialogTitle>
                Question
            </DialogTitle>
            <DialogContent dividers={true}>
                <div className={classes.contentContainer}>
                    {/*main info*/}
                    <div className={classes.content} style={{width: '50%'}}>
                        <div className={classes.contentBordered}>
                            <DefaultType
                                values={question}
                                setValue={onChangeFields}
                                field={{
                                    type: 'string',
                                    path: `name`,
                                    label: "Question ID",
                                }}
                                fieldStyles={{
                                    width: 350,
                                    fullWidth: true,
                                }}
                                labelStyles={{width: 130}}
                            />
                            <DefaultType
                                values={question}
                                setValue={onChangeFields}
                                field={{
                                    type: 'string',
                                    path: `label`,
                                    label: "Question Label",
                                    multiLanguage: true
                                }}
                                fieldStyles={{
                                    width: 350,
                                    fullWidth: true,
                                }}
                                labelStyles={{width: 130}}
                            />
                            {surveyType === 'scoring' && (
                                <DefaultType
                                    values={question}
                                    setValue={onChangeFields}
                                    field={{
                                        type: 'number',
                                        path: `weight`,
                                        label: "Question Weight",
                                    }}
                                    fieldStyles={{
                                        width: 350,
                                        fullWidth: true,
                                    }}
                                    labelStyles={{width: 130}}
                                />
                            )}
                            <DefaultType
                                values={question}
                                setValue={onChangeFields}
                                field={{
                                    type: 'select',
                                    values: ['field', 'choice'],
                                    path: `type`,
                                    label: "Type",
                                }}
                                fieldStyles={{
                                    width: 350,
                                    fullWidth: true,
                                }}
                                labelStyles={{width: 130}}
                            />
                        </div>
                    </div>
                        {!selectedType ? (
                            <div className={classes.noSelectedContainer}>
                                <Typography color={'textSecondary'}>Question type is not selected</Typography>
                            </div>) : (
                            <div>
                                {(surveyType === 'scoring' && selectedType === 'field') && (
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        width: '100%',
                                    }}>
                                        <div style={{display: 'flex', gap: 20, width: '100%'}}>
                                            <div className={classes.content}>
                                                <Typography variant={"h6"}>Value</Typography>
                                                <div className={classes.contentBordered}>
                                                    <div>
                                                        <TypeEntity
                                                            values={question}
                                                            setValue={onChangeFields}
                                                            field={{
                                                                path: `answerValue.entity`,
                                                                label: "Entity",
                                                                entity: 'schema'
                                                            }}
                                                            fieldStyles={{
                                                                width: 350,
                                                                fullWidth: true,
                                                            }}
                                                            labelStyles={{width: 130}}
                                                        />
                                                        <DefaultType
                                                            values={question}
                                                            setValue={onChangeFields}
                                                            field={{
                                                                type: 'string',
                                                                path: `answerValue.field`,
                                                                label: "Field",
                                                            }}
                                                            fieldStyles={{
                                                                width: 350,
                                                                fullWidth: true,
                                                            }}
                                                            labelStyles={{width: 130}}
                                                        />
                                                        <ScriptType
                                                            values={question}
                                                            setValue={onChangeFields}
                                                            field={{
                                                                path: `answerValue.script`,
                                                                label: "Script",
                                                            }}
                                                            fieldStyles={{
                                                                width: 350,
                                                                fullWidth: true,
                                                            }}
                                                            labelStyles={{width: 130}}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={classes.content}>
                                                <Typography variant={"h6"}>Field Properties</Typography>
                                                <div className={classes.contentBordered} style={{overflow: 'auto'}}>
                                                    <FieldPropertiesComponent
                                                        values={question.field}
                                                        setValue={onChangeFields}
                                                        collapsible={true}
                                                        component={{
                                                            properties: {
                                                                dataSource: `field`
                                                            },
                                                            styles: [{
                                                                padding: "10px",
                                                                height: 220,
                                                                fullWidth: true,
                                                                overflow: 'auto'
                                                            }]
                                                        }}/>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <Typography variant={"h6"}>Points</Typography>
                                            <div className={classes.contentBordered}
                                                 style={{display: 'flex', gap: 20, width: '100%'}}>
                                                <div className={classes.content} style={{gap: 10}}>
                                                    <Typography variant={"subtitle2"}>Points Conditions</Typography>
                                                    <PointsConditions
                                                        values={question}
                                                        onChangeFields={onChangeFields}
                                                        addGroup={addGroup}
                                                        removeGroup={removeGroup}
                                                    />
                                                </div>
                                                <div className={classes.content}>
                                                    <PointsScript
                                                        question={question}
                                                        onChangeFields={onChangeFields}
                                                    />

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div style={{width: '100%'}}>
                                    {selectedType === 'choice' ? (
                                        <>
                                            <Typography variant={"subtitle2"} style={{padding: '5px 0'}}>
                                                Choices
                                            </Typography>
                                            <Choices record={question}
                                                     onChange={onChangeFields}
                                            />
                                        </>
                                    ) : <></>}
                                </div>
                            </div>
                        )}
                    </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => {
                    saveQuestion(question)
                    onClose()
                    setIsChanged(false)
                }} variant={"contained"} size={'small'} color="primary">Save</Button>
                <Button onClick={onCloseDialog}
                        variant={"contained"}
                        size={'small'}
                        color="default"
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    )
}
export default QuestionModal;